import {useCallback, useEffect} from "react";

import "../styles/Modal.css";

const Modal = ({ show, header, children: content, footer, onClose }) => {
    const closeOnEscape = useCallback(e => e.key === 'Escape' && onClose(), [onClose]);

    useEffect(() => {
        document.body.addEventListener("keydown", closeOnEscape);

        return () => document.body.removeEventListener("keydown", closeOnEscape);
    }, [closeOnEscape]);

    return (
        <div className={`modal ${show ? 'show' : ''}`} onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">{header}</div>
                <div className="modal-body">{content}</div>
                <div className="modal-footer">{footer}</div>
            </div>
        </div>
    );
}

export default Modal;